// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flex {\n    display: flex;\n}\n\n.f-d-c {\n    flex-direction: column;\n}\n\n.f-jc-c {\n    justify-content: center;\n}\n\n.f-ai-c {\n    align-items: center;\n}\n\n.f-wrap {\n    flex-wrap: wrap;\n}\n\n.box {\n    box-sizing: border-box;\n}\n\n.pr {\n    position: relative;\n}\n\n.fz-12 {\n    font-size: 12px;\n}\n.fz-14 {\n    font-size: 14px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
